import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "magento_indexer-module"
    }}>{`Magento_Indexer module`}</h1>
    <p>{`This module provides Magento Indexing functionality.
It allows to:`}</p>
    <ul>
      <li parentName="ul">{`read indexers configuration`}</li>
      <li parentName="ul">{`represent indexers in admin`}</li>
      <li parentName="ul">{`regenerate indexes by cron schedule`}</li>
      <li parentName="ul">{`regenerate indexes from console`}</li>
      <li parentName="ul">{`view and reset indexer state from console`}</li>
      <li parentName="ul">{`view and set indexer mode from console`}</li>
    </ul>
    <h2 {...{
      "id": "installation"
    }}>{`Installation`}</h2>
    <p>{`The Magento_Indexer module is one of the base Magento 2 modules. You cannot disable or uninstall this module.`}</p>
    <p>{`This module is dependent on the following modules:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Magento_Store`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`Magento_AdminNotification`}</inlineCode></li>
    </ul>
    <p>{`The Magento_Indexer module creates the following tables in the database:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`indexer_state`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`mview_state`}</inlineCode></li>
    </ul>
    <p>{`For information about a module installation in Magento 2, see `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/commerce-operations/installation-guide/tutorials/manage-modules.html"
      }}>{`Enable or disable modules`}</a>{`.`}</p>
    <h2 {...{
      "id": "structure"
    }}>{`Structure`}</h2>
    <p><inlineCode parentName="p">{`App/`}</inlineCode>{` - the directory that contains launch application entry point.`}</p>
    <p>{`For information about a typical file structure of a module in Magento 2, see `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/php/development/build/component-file-structure/#module-file-structure"
      }}>{`Module file structure`}</a>{`.`}</p>
    <h2 {...{
      "id": "extensibility"
    }}>{`Extensibility`}</h2>
    <p>{`Extension developers can interact with the Magento_Indexer module. For more information about the Magento extension mechanism, see `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/php/development/components/plugins/"
      }}>{`Magento plugins`}</a>{`.`}</p>
    <p><a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/php/development/components/dependency-injection/"
      }}>{`The Magento dependency injection mechanism`}</a>{` enables you to override the functionality of the Magento_Indexer module.`}</p>
    <h3 {...{
      "id": "events"
    }}>{`Events`}</h3>
    <p>{`The module dispatches the following events:`}</p>
    <h4 {...{
      "id": "model"
    }}>{`Model`}</h4>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`clean_cache_by_tags`}</inlineCode>{` event in the `}<inlineCode parentName="li">{`\\Magento\\Indexer\\Model\\Indexer\\CacheCleaner::cleanCache`}</inlineCode>{` method. Parameters:`}
        <ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`object`}</inlineCode>{` is a `}<inlineCode parentName="li">{`cacheContext`}</inlineCode>{` object (`}<inlineCode parentName="li">{`Magento\\Framework\\Indexer\\CacheContext`}</inlineCode>{` class)`}</li>
        </ul>
      </li>
    </ul>
    <h4 {...{
      "id": "plugin"
    }}>{`Plugin`}</h4>
    <ul>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`clean_cache_after_reindex`}</inlineCode>{` event in the `}<inlineCode parentName="p">{`\\Magento\\Indexer\\Model\\Processor\\CleanCache::afterUpdateMview`}</inlineCode>{` method. Parameters:`}</p>
        <ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`object`}</inlineCode>{` is a `}<inlineCode parentName="li">{`context`}</inlineCode>{` object (`}<inlineCode parentName="li">{`Magento\\Framework\\Indexer\\CacheContext`}</inlineCode>{` class)`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`clean_cache_by_tags`}</inlineCode>{` event in the `}<inlineCode parentName="p">{`\\Magento\\Indexer\\Model\\Processor\\CleanCache::afterReindexAllInvalid`}</inlineCode>{` method. Parameters:`}</p>
        <ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`object`}</inlineCode>{` is a `}<inlineCode parentName="li">{`context`}</inlineCode>{` object (`}<inlineCode parentName="li">{`Magento\\Framework\\Indexer\\CacheContext`}</inlineCode>{` class)`}</li>
        </ul>
      </li>
    </ul>
    <p>{`For information about an event in Magento 2, see `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/php/development/components/events-and-observers/#events"
      }}>{`Events and observers`}</a>{`.`}</p>
    <h3 {...{
      "id": "layouts"
    }}>{`Layouts`}</h3>
    <p>{`This module introduces the following layout handles in the `}<inlineCode parentName="p">{`view/adminhtml/layout`}</inlineCode>{` directory:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`indexer_indexer_list`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`indexer_indexer_list_grid`}</inlineCode></li>
    </ul>
    <p>{`For more information about layouts in Magento 2, see the `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/frontend-core/guide/layouts/"
      }}>{`Layout documentation`}</a>{`.`}</p>
    <h2 {...{
      "id": "additional-information"
    }}>{`Additional information`}</h2>
    <h3 {...{
      "id": "indexer-modes"
    }}>{`Indexer modes`}</h3>
    <p>{`There are 2 modes of the Indexers:`}</p>
    <ul>
      <li parentName="ul">{`Update on Save - index tables are updated immediately after the dictionary data is changed`}</li>
      <li parentName="ul">{`Update by Schedule - index tables are updated by cron job according to the configured schedule`}</li>
    </ul>
    <h3 {...{
      "id": "console-commands"
    }}>{`Console commands`}</h3>
    <p>{`Magento_Indexers provides console commands:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`bin/magento indexer:info`}</inlineCode>{` - view a list of all indexers`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`bin/magento indexer:status [indexer]`}</inlineCode>{` - view index status`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`bin/magento indexer:reindex [indexer]`}</inlineCode>{` - run reindex`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`bin/magento indexer:reset [indexer]`}</inlineCode>{` - reset indexers`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`bin/magento indexer:show-mode [indexer]`}</inlineCode>{` - view the current indexer configuration`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`bin/magento indexer:set-mode {realtime|schedule} [indexer]`}</inlineCode>{` - specify the indexer configuration`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`bin/magento indexer:set-dimensions-mode [indexer]`}</inlineCode>{` - set indexer dimension mode`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`bin/magento indexer:show-dimensions-mode [indexer]`}</inlineCode>{` - set indexer dimension mode`}</li>
    </ul>
    <h3 {...{
      "id": "cron-options"
    }}>{`Cron options`}</h3>
    <p>{`Cron group configuration can be set at `}<inlineCode parentName="p">{`etc/crontab.xml`}</inlineCode>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`indexer_reindex_all_invalid`}</inlineCode>{` - regenerate indexes for all invalid indexers`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`indexer_update_all_views`}</inlineCode>{` - update indexer views`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`indexer_clean_all_changelogs`}</inlineCode>{` - clean indexer view changelogs`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/commerce-operations/configuration-guide/cli/configure-cron-jobs.html"
      }}>{`Learn how to configure and run cron in Magento.`}</a>{`.`}</p>
    <p>{`More information can get at articles:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.adobe.com/commerce/php/development/components/indexing/"
        }}>{`Learn more about indexing`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.adobe.com/commerce/php/development/components/indexing/optimization/"
        }}>{`Learn more about Indexer optimization`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.adobe.com/commerce/php/development/components/indexing/custom-indexer/"
        }}>{`Learn more how to add custom indexer`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://experienceleague.adobe.com/docs/commerce-operations/configuration-guide/cli/manage-indexers.html"
        }}>{`Learn how to manage indexers`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://experienceleague.adobe.com/docs/commerce-admin/systems/tools/index-management.html"
        }}>{`Learn more about Index Management`}</a></li>
    </ul>
    <InlineAlert slots="text" mdxType="InlineAlert" />
The version of this module is 100.4.7.

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      